<template>
  <div class="footers">
    <div class="top">
      <div @click="setActiveTab('home')" style="cursor: pointer;">首页</div>
      <div class="online">|</div>
      <div @click="setActiveTab('AboutUs')" style="cursor: pointer;">艺人库</div>
    </div>
    <div class="bottom">{{ recordNumber }}</div>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex';
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      recordNumber: ''
    };
  },
  created() { },
  computed: {},
  mounted() {
    this.getDetial()
  },
  methods: {
    ...mapActions([
      'setSaveHigh'
    ]),
     // 点击跳转页面
     setActiveTab(tab) {
      // 切换页面时清除输入
      if (tab !== 'AboutUs') this.input = ''
      this.setSaveHigh(tab)
      this.$router.push({ name: tab })
    },
    getDetial(){
      this.$http.get('/api/index/getconinfo')
        .then(res => {
          if (res.status == 200) {
            this.recordNumber = res.data.data.site_icp
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
    }
  }
};
</script>
 
<style lang="scss" scoped>
.footers {
.top{
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  color: #292929;
  .online{
    margin: 0 30px;
  }
}
.bottom{
  color: #C1C1C1;
  font-size: 12px;
}
}
</style>